import {Component, OnInit, AfterViewInit} from '@angular/core';
import {DataService} from '../../../../Services/data.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../../Services/storage.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppConfigService } from '../../../../Services/app-config.service';
import { NotificationService } from '../../../../Services/notification.service';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-company-access-list',
  templateUrl: './company-access-list.component.html',
  styleUrls: ['./company-access-list.component.css'],
  standalone: false
})
export class CompanyAccessListComponent extends ListPageBase implements OnInit, AfterViewInit {
  constructor(
    private aTable: DataService,
    private aToastr: NotificationService,
    private aRoute: Router,
    private aStorage: StorageService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  companyAccessCount = 0;
  isLoaded = false;




  vm: any = [];

  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.getData();
  }


  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Company Access List @@companyAccessList:Company Access List`);
  }




  getData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('company_access', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.companyAccessCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error(
          $localize`:Error loading Company Data @@errorLoadingCompanyData:Error loading Company Data`
        );
        console.log(error);
      },
      () => {}
    );
  }

  onNavigate(aID: string) {
    this.aRoute.navigate(['admin/company-access-form', { id: aID }]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.aTable.getApiListData('company_access', paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);

        this.companyAccessCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        this.aToastr.error(
          $localize`:Error loading Company Data @@errorLoadingCompanyData:Error loading Company Data`
        );
        console.log(error);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }

}
